<template lang="pug">
  include /mixins
  +b.tt-card-product-inner.--offset_none.--package-product.relative(v-if='product && productItem')
    ui-loader(v-if='load || localLoad')
    //- +b.tt-cart-action.--absolute.--top-right
      add-to-favorites(
        :id='productItem.props.id || product.props.id'
        :is-liked="productItem.props.is_favorite || product.props.is_favorite"
        v-if='is_auth'
      )
        //- @hook:remove="$emit('hook:remove', $event)"
        template(#default='{ add, is_added, remove }')
          +b.tt-cart-action(v-if='is_added' @click.prevent='remove')
            +e.icon
              +b.circle-btn.--grey.--clear.--transparent.BUTTON(
                :title="_('В избранном')"
              )
                +e.icon.IMG(
                  src="/static/img/full-heart.svg"
                  :alt='_("full heart")'
                )
          +b.tt-cart-action(@click.prevent='add' v-else)
            +e.icon
              +b.circle-btn.--grey.--clear.--transparent.BUTTON(
                :title="_('Добавить в избранное')"
              )
                +e.icon.--small.icon-like.SPAN
      modal-trigger(
        v-else
        url='UiElements/NotPermission',
        name='NotPermission',
      )
        template(#default='{ open }')
          +b.tt-cart-action(@click.prevent='open')
            +e.title
              +b.ds-caption--size_2md.--semibold.--color_accent.--appearance_nowrap {{ _('To favorite') }}
            +e.icon
              +b.circle-btn.--grey.--clear.--transparent.BUTTON(
                :title="_('Добавить в избранное')"
              )
                +e.icon.icon-like.SPAN
    +e.labels.variant-view(
      :class="{'is-active' : true}"
    )
      template(v-if="product.props.is_new || productItem.props.is_new")
        +e.label
          +b.label--static.--variant_1.is_new
            +e.title.--size_1.P {{ _('new') }}
      template(v-if="product.props.is_sale || productItem.props.is_sale")
        +e.label
          +b.label--static.--variant_1.is_sale
            +e.title.--size_1.P {{ _('акция') }}
      template(v-if="product.props.is_new_package || productItem.props.is_new_package")
        +e.label
          +b.label--static.--variant_1.is_new_package
            +e.title.--size_1.P {{ _('Новая упаковка') }}
      template(v-if="product.props.is_hit || productItem.props.is_hit")
        +e.label
          +b.label--static.--variant_1.is_top
            +e.title.--size_1.P {{ _('ТОП') }}
    +b.g-row.--align_center.full-h
      +b.g-cell.g-cols--4.--12-sm.tt-space_mb--2
        +b.g-row.--space_none.--justify_center
          +b.g-cell.g-cols--narrow
            +b.tt-picture--size_auto.--size_auto-h.tt-cart-product-img.PICTURE.relative
              source(
                type="image/webp"
                :srcset="product.props.img && product.props.img.catalog_preview_webp"
              )
              +e.body.IMG(
                v-if='product.props.img && product.props.img.catalog_preview'
                :src='product.props.img && product.props.img.catalog_preview',
                :alt='product.props.title',
              )
              +e.body.IMG(
                v-else
                src='https://via.placeholder.com/60x60',
              )
      +b.g-cell.g-cols--auto.--12-sm
        +b.g-row
          +b.g-cell.g-cols--11.tt-space_mb--1
            +b.ds-caption--size_xs.--medium.P(
              v-if='productItem.props.brand || product.props.brand'
            ) {{ productItem.props.brand ? productItem.props.brand.caption : product.props.brand.caption }}
          +b.g-cell.g-cols--12.tt-space_mb--2
            +b.ds-caption--size_sm.--size_sm-xl.--bold.A.tt-link--variant_start(
              v-if="productItem.props.variant_url"
              :href='productItem.props.variant_url'
              target="_blank"
            ) {{ product.props.title }}
            +b.ds-caption--size_sm.--size_sm-xl.--bold.A.tt-link--variant_start(
              v-else
              :href='product.props.variant_url'
              :class='{ "is-disabled": !product.props.show_in_catalog }'
            ) {{ product.props.title }}
                //- +b.g-row.--justify_between.full-h
                //-   +b.g-cell.g-cols--12
                  //- +b.g-cell.g-cols--6.--3-xl.is-visible-xl
                  //-   +b.ds-caption--size_sm.--semibold.--appearance_right.P(
                  //-     v-html='getSplittedHtml(product.props.price)'
                  //-   )
          +b.g-cell.g-cols--12.flex_1.tt-space_mb--3
            +b.ds-caption--size_2xs.--light.P(v-if="product.props.product" v-html='product.props.product.props.short_description')
            +b.ds-caption--size_2xs.--light.P(v-else v-html='productItem.props.short_description')
              //- +b.g-cell.g-cols--12.tt-space_mt--3.is-disable-xl
                +b.g-row
                  +b.g-cell.g-cols--6
                    +b.ds-caption--size_xs.--medium.P(
                      v-if='product.props.weight'
                    ) {{ product.props.weight.props.name }}
                  +b.g-cell.g-cols--6
                    +b.ds-caption--size_sm.--semibold.--appearance_right.P(
                      v-html='getSplittedHtml(product.props.price)'
                    )
      +b.g-cell.g-cols--12
        row(
          justify='between'
          align='center'
        )
          +b.g-cell.g-cols--6.--6-xl
            +b.tt-counter.--variant_1.COUNTER(
              :amount='0',
              :disable='disabled'
              v-model='product.props.quantity'
              :max-count='product.props.stock || productItem.props.stock'
              :min-count='0'
              @change="onInputChange"
              @immediately="sendChanges"
            )
          +b.g-cell.g-cols--narrow-sm
            //- pre {{  productItem.props.price_definition }}
            +b.ds-caption--size_sm.--semibold.--appearance_right.P(
              v-if="productItem.props.price_definition"
              v-html='getSplittedHtml(priceGetter(productItem.props.price_definition))'
            )
            +b.ds-caption--size_sm.--semibold.--appearance_right.P(
              v-else
              v-html='getSplittedHtml(product.props.price)'
            )
      //- +b.g-cell.g-cols--6.--3-xl
        slot(
          name='total',
        )
          row(
            justify='end'
            align='center'
          )
            cell(
              cols='12-xl'
            )
              slot(
                name='price-tips'
              )
                +b.ds-caption--size_sm.--light.--appearance_right.P  {{ _('Сумма:') }}
            cell(
              cols='12-xl'
            )
              +b.ds-caption--size_sm.--semibold.--appearance_right.P(
                v-html='getSplittedHtml(product.props.price * (product.props.quantity || 0))'
              )
</template>
<script>

import {
  mapActions,
} from 'vuex'

export default {
  name: 'ProductPackageView',
  props: {
    isGift: {},
    product: {
      default: () => {},
    },
    price: {
      default: '0.00',
    },
    isSale: {
      default: () => false,
    },
    load: {},
    disabled: {
      default: () => false,
    },
    parent: {},
    relations: {
      default: () => [],
    },
  },
  data() {
    return {
      quantity: 0,
      currency: window.currency,
      lang: window.language,
      localLoad: false,
      is_auth: window.authent,
    }
  },
  computed: {
    productItem () {
      return this.product.props.product || this.product.props.variant
    },
    // promo() {
    //   return this.relations.find(e => e.element.type === PROMO_TYPE)
    // },
    // saleInfo() {
    //   if (this.relations.length) {
    //     const [rel] = this.relations
    //     return rel
    //   }
    //   return {}
    // },
    // isLimited() {
    //   return this.product.quantity >= this.product.props.stock
    // },
    // stockInfo() {
    //   return this.product.stock_info
    // },
  },
  methods: {
    ...mapActions('cart', [
      'getCart',
    ]),
    priceGetter(price) {
      const [p] = price?.user?.ranged_prices
      return p?.sale_price || p?.default_price
    },
    onInputChange(value) {
      console.log("🚀 ~ value:", value)
      this.$emit('updateCart', value);
      this.$emit('updatePrice', { 
        id: this.product.props?.variant ? this.product.props.variant.id : this.product.props.id, 
        summ: Number((this.productItem?.props?.price_definition ? this.priceGetter(this.productItem.props.price_definition) : this.product.props.price) * value.count),
        count: value.count });
      },
    sendChanges(value) {
      this.$emit('updatePrice', { 
        id: this.product.props?.variant ? this.product.props.variant.id : this.product.props.id, 
        summ: Number((this.productItem?.props?.price_definition ? this.priceGetter(this.productItem.props.price_definition) : this.product.props.price) * value.count),
        count: value.count });
    }
  },
}
</script>
